module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"copied":"Link kopiert!"},"en":{"copied":"Link copied!"},"it":{"copied":""},"lt":{"copied":"Nuoroda nukopijuota!"},"pl":{"copied":"Skopiowany!"}}')
  delete Component.options._Ctor
}
